exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activityComponent {\n}\n\n.activityEditorsIcon {\n    margin-left: 14px;\n}\n\n.activityEditorsAndViewersIcons {\n    float: left;\n    margin-left: 14px;\n}\n\n.activityViewersIcon {\n    float: left;\n    margin-left: 14px;\n}\n", ""]);

// exports
